import { Theme, createStyles } from '@material-ui/core/styles';


export const styles = (theme: Theme) => createStyles({
  root: {
    margin: '0px 4% 359px 28%',
    fontFamily: 'MuseoSans, sans-serif',
    display: 'grid',
    gridTemplateColumns: '50% 50%',
    gridTemplateRows: 'auto auto auto auto auto',
    [theme.breakpoints.down(1200)]: {
      margin: '0px 4% 359px 23%',
    },
    [theme.breakpoints.down(1001)]: {
      margin: '0px 4% 250px 20%',
    },
    [theme.breakpoints.down(905)]: {
      margin: '0px 4% 250px 16%',
    },
    [theme.breakpoints.down(850)]: {
      margin: '0px 4% 210px 16%',
    },
    [theme.breakpoints.down(701)]: {
      display:'flex',
      flexDirection: 'column',
      margin: '0px 20% 180px 25%',
    },
    [theme.breakpoints.down(550)]: {
      margin: '0px 20% 150px 23%',
    },
    [theme.breakpoints.down(500)]: {
      margin: '0px 20% 120px 20%',
    },
    [theme.breakpoints.down(400)]: {
      margin: '0px 10% 100px 18%',
    },
    [theme.breakpoints.down(350)]: {
      margin: '0px 5% 100px 18%',
      '& img': {
          width: '90% !important',
      },
    },
  },
  title: {
    fontWeight: 500,
    fontSize: '36px',
    letterSpacing: '2.51px',
    lineHeight: '50px',
    color: theme.palette.primary.main,
    marginBottom: '9vh',
    '& span': { fontWeight: 900, },
    [theme.breakpoints.down(1200)]: {
      marginBottom: '8vh',
    },
    [theme.breakpoints.down(1001)]: {
        fontSize: '31px',
        lineHeight: '45px',
    },
    [theme.breakpoints.down(850)]: {
      marginBottom: '7vh',
    },
    [theme.breakpoints.down(701)]: {
      fontSize: '26px',
      lineHeight: '35px',
      marginBottom: '55px',
      marginTop:'10%'
    },
    [theme.breakpoints.down(550)]: {
      fontSize: '23px',
      lineHeight: '30px',
      marginBottom: '45px',
    },
    [theme.breakpoints.down(450)]: {
      fontSize: '21px',
      lineHeight: '27px',
    },
    [theme.breakpoints.down(400)]: {
      fontSize: '19px',
      lineHeight: '25px',
    },
  },
  text: {
    fontWeight: 500,
    fontSize: '18.3px',
    letterSpacing: '0.7px',
    lineHeight: '26.35px',
    color: theme.palette.primary.main,
    '& span': { color: theme.palette.primary.dark },
    [theme.breakpoints.down(1001)]: {
        fontSize: '15.5px',
        lineHeight: '25px',
    },
    [theme.breakpoints.down(701)]: {
      fontSize: '15px',
      lineHeight: '22px',
    },
    [theme.breakpoints.down(550)]: {
      fontSize: '13px',
      lineHeight: '21px',
    },
    [theme.breakpoints.down(450)]: {
      fontSize: '12px',
      lineHeight: '20px',
    },
    [theme.breakpoints.down(400)]: {
      fontSize: '11px',
      lineHeight: '19px',
    },
    [theme.breakpoints.down(350)]: {
      lineHeight: '18px',
    },
  },
  link: {
    color: theme.palette.primary.dark,
    textDecoration: 'none',
  },
  image:{
  },

  bottomText: {
    fontFamily: 'MuseoSans, sans-serif',
    fontWeight: 500,
    fontSize:'36px',
    color: '#3D4274',
    letterSpacing: '0.57px',
    lineHeight:'40px',
    textAlign: 'center',
    marginLeft: '0em' ,
    marginRight: '0em' ,
    marginBottom: '5em',
    [theme.breakpoints.down(1170)]: {
      fontSize: '34px',
    },
    [theme.breakpoints.down(1150)]: {
      fontSize: '32px',
    },
    [theme.breakpoints.down(1001)]: {
      fontSize: '30px',
    },
    [theme.breakpoints.down(1100)]: {
      fontSize: '28px',
    },
    [theme.breakpoints.down(950)]: {
      fontSize: '26px',
    },
    [theme.breakpoints.down(900)]: {
      fontSize: '24px',
    },
    [theme.breakpoints.down(850)]: {
      marginBottom: '3.5em',
      lineHeight: '35px',
      marginLeft:'15%',
      marginRight:'15%',
    },
    [theme.breakpoints.down(550)]: {
      fontSize: '23px',
      lineHeight: '31px',
      marginLeft:'10%',
      marginRight:'10%',
    },
    [theme.breakpoints.down(500)]: {
      fontSize: '20px',
      lineHeight: '29px',
    },
    [theme.breakpoints.down(450)]: {
      fontSize: '18px',
      lineHeight: '27px',
      marginLeft:'12%',
      marginRight:'12%',
    },
    [theme.breakpoints.down(370)]: {
      fontSize: '15px',
      lineHeight: '20px',
      marginLeft:'16%',
      marginRight:'16%',
    },
  },
});
